/* BRYVO theme — quiz.js
   Branching enquiry form. Steps are fieldsets; which ones appear depends on the
   answer to the question marked as the branch. Everything still posts through
   Shopify's own contact form, so nothing here is required for it to work.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';

  function boot(form) {
    if (!form || form.dataset.quizReady === 'true') return;
    var scope = form.querySelector('[data-quiz]');
    if (!scope) return;
    form.dataset.quizReady = 'true';

    var steps = Array.prototype.slice.call(scope.querySelectorAll('[data-step-q]'));
    if (!steps.length) return;

    var branchStep = scope.querySelector('[data-branch]');
    var nav = form.querySelector('[data-quiz-nav]');
    var btnNext = form.querySelector('[data-quiz-next]');
    var btnPrev = form.querySelector('[data-quiz-prev]');
    var bar = form.querySelector('[data-quiz-bar]');
    var count = form.querySelector('[data-quiz-count]');
    var pct = form.querySelector('[data-quiz-pct]');
    var prog = form.querySelector('[data-quiz-prog]');
    var err = form.querySelector('[data-quiz-err]');
    var summary = form.querySelector('[data-quiz-summary]');
    var reviewStep = scope.querySelector('[data-review]');

    var index = 0;
    if (prog) prog.hidden = false;

    function branchValue() {
      if (!branchStep) return null;
      var picked = branchStep.querySelector('input:checked');
      return picked ? (picked.dataset.value || picked.value) : null;
    }

    function isVisible(step) {
      var when = step.dataset.when;
      if (!when) return true;
      var v = branchValue();
      if (!v) return false;
      return when.split(',').map(function (s) { return s.trim(); }).indexOf(v) > -1;
    }

    function visible() { return steps.filter(isVisible); }

    function show(i, dir) {
      var list = visible();
      index = Math.max(0, Math.min(i, list.length - 1));
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      var step = list[index];
      step.classList.add('is-active');

      if (btnPrev) btnPrev.style.visibility = index === 0 ? 'hidden' : 'visible';
      var last = index === list.length - 1;
      if (btnNext) btnNext.hidden = last;

      if (bar) bar.style.width = Math.round(((index + 1) / list.length) * 100) + '%';
      if (count) count.textContent = 'Step ' + (index + 1) + ' of ' + list.length;
      if (pct) pct.textContent = Math.round(((index + 1) / list.length) * 100) + '%';
      if (err) err.textContent = '';

      if (step === reviewStep) buildSummary();

      if (dir) {
        var top = form.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      var first = step.querySelector('input, textarea, select');
      if (first && dir === 'next') {
        // Move focus without yanking the page around.
        setTimeout(function () { first.focus({ preventScroll: true }); }, 220);
      }
    }

    function validate(step) {
      var required = step.querySelectorAll('[data-req]');
      var groupsChecked = {};
      var missing = null;

      Array.prototype.forEach.call(required, function (input) {
        if (missing) return;
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (groupsChecked[input.name]) return;
          var any = step.querySelector('input[name="' + CSS.escape(input.name) + '"]:checked');
          groupsChecked[input.name] = true;
          if (!any) missing = 'Pick one to carry on.';
          return;
        }
        if (!input.value.trim()) missing = 'That one is needed before we can go on.';
        else if (input.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value)) missing = 'That email address does not look right.';
      });

      if (missing && err) {
        err.textContent = missing;
        var firstBad = step.querySelector('[data-req]');
        if (firstBad) firstBad.focus({ preventScroll: true });
      }
      return !missing;
    }

    function labelFor(step) {
      var h = step.querySelector('.step__q');
      return h ? h.textContent.trim() : (step.dataset.key || '');
    }

    function answerFor(step) {
      var picked = Array.prototype.slice.call(step.querySelectorAll('input:checked'));
      if (picked.length) return picked.map(function (p) { return p.value; }).join(', ');
      var free = Array.prototype.slice.call(step.querySelectorAll('input[type="text"], input[type="url"], input[type="email"], input[type="tel"], textarea'));
      var values = free.map(function (f) { return f.value.trim(); }).filter(Boolean);
      return values.join(' · ');
    }

    function buildSummary() {
      if (!summary) return;
      summary.innerHTML = '';
      visible().forEach(function (step) {
        if (step === reviewStep) return;
        var a = answerFor(step);
        if (!a) return;
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = labelFor(step);
        dd.textContent = a;
        row.appendChild(dt);
        row.appendChild(dd);
        summary.appendChild(row);
      });
      if (!summary.children.length) {
        var empty = document.createElement('div');
        empty.innerHTML = '<dt>Nothing yet</dt><dd>Go back and answer a question or two.</dd>';
        summary.appendChild(empty);
      }
    }

    if (btnNext) btnNext.addEventListener('click', function () {
      var list = visible();
      if (!validate(list[index])) return;
      show(index + 1, 'next');
    });

    if (btnPrev) btnPrev.addEventListener('click', function () { show(index - 1, 'prev'); });

    // Re-evaluate which steps exist as soon as the branch answer changes, so the
    // step count, the bar and the percentage all agree.
    if (branchStep) {
      branchStep.addEventListener('change', function () { show(index); });
    }

    // Pointer-only auto-advance on single-choice steps: pressing an arrow key to
    // move between radios must not skip the question.
    scope.addEventListener('click', function (e) {
      var input = e.target.closest('input[type="radio"]');
      if (!input || e.detail === 0) return;
      var step = input.closest('[data-step-q]');
      if (!step || step.dataset.key === 'details') return;
      setTimeout(function () {
        var list = visible();
        if (list[index] === step && index < list.length - 1) show(index + 1, 'next');
      }, 340);
    });

    // On submit: collapse each multi-answer question into one readable value, and
    // drop every question that was not on this visitor's path.
    form.addEventListener('submit', function () {
      scope.querySelectorAll('[data-multi-value]').forEach(function (hidden) {
        var step = hidden.closest('[data-step-q]');
        var boxes = step.querySelectorAll('input[type="checkbox"]');
        var picked = Array.prototype.filter.call(boxes, function (b) { return b.checked; })
          .map(function (b) { return b.value; });
        boxes.forEach(function (b) { b.disabled = true; });
        if (picked.length) {
          hidden.value = picked.join(', ');
          hidden.disabled = false;
        }
      });

      steps.forEach(function (step) {
        if (isVisible(step)) return;
        Array.prototype.forEach.call(step.querySelectorAll('input, textarea, select'), function (f) { f.disabled = true; });
      });
    });

    show(0);
  }

  function initAll(root) {
    (root || document).querySelectorAll('form.quiz').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
